import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import * as encoding from 'encoding-japanese';

import { SuppService } from '../../../service/supp/supp.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { OwnerService } from '../../../service/owner/owner.service';

@Component({
  selector: 'app-root',
  templateUrl: 'wa5020.component.html',
  styleUrls: ['wa5020.component.scss']
})
export class Wa5020Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA5020:補充照会';
  public updprogramCd = 'WA5020';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  private originalRowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  public reporttrnId: number;
  private reportOpened = false;
  private reportTry = 0;
  public excelFl = 0;
  public errorInfo: string = '';

  public Item: number = 0;
  private isFilterExcludeMoveCompleteChecked = false;
  private errorMssage = '';
  public openWindow: boolean = false;
  private errorMssage2 = '';
  private ownerRowData: any[];
  private ownerGridHelper: AgGridHelper;
  private ownerGridHeight = 300;
  private ownerGridOptions: GridOptions;

  private gridHelper: AgGridHelper;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  @ViewChild('gridView')
  gridView: ElementRef;

  private isEnableClearFilter = false;
  private isShowRemoveModal = false;
  private url;

  //pagination
  private totalCount = 0;
  private currentPage = 0;
  private maxPage = 0;
  private selectedCount = 0;

  private isShow5030 = false;

  private isOwnerSearchNone = false;
  private paginationGetRowCount = 0;

  constructor(
    private router: Router,
    private suppService: SuppService,
    private pdfReportService: PdfReportService,
    private commonService: CommonService,
    private ownerService: OwnerService,
    private el: ElementRef,
    private dialogsService: DialogsService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa5020_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        // grid初期化完了後行うこと
        this.gridHelper.onGridReady();
        this.gridHelper.autoTogglePagination();
      },
      onFilterChanged: () => {
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
      },
      /*
      onRowDataChanged: () => {
        this.filterGridByMove();
        this.gridHelper.onRowDataChanged();
        this.errorInfo = '';

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      */
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.maxPage = this.gridOptions.api.paginationGetTotalPages();
        this.currentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.autoTogglePagination();
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'checkbox',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 40,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left'
      },
      {
        headerName: '',
        field: 'col1Scroll:100',
        suppressMenu: true,
        width: 8,
        cellClass: ['tc', 'cellclass'],
        hide: true,
        pinned: 'left',
        cellStyle: function (params) {
          //ステータス色変化
          if (params.data.stsuppTx == '未補充' || params.data.stsuppTx == '印刷完了') {
            return { backgroundColor: 'rgba(235,153,175,0.2)', color: '#eb99af' };
          } else if (params.data.stsuppTx == '補充元出庫開始' || params.data.stsuppTx == '補充元出庫完了' ||params.data.stsuppTx == '補充先入庫開始') {
            return { backgroundColor: 'rgba(227,230,87,0.2)', color: 'rgba(227,230,87,0.2)' };
          } else if (params.data.stsuppTx == '補充先入庫完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)', color: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '補充タイプ',
        field: 'typesuppTx',
        width: this.getColumnWidth('typesuppTx', 90),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        cellStyle: function (params) {
          //ステータス色変化
          if (params.value == '緊急') {
            return { color: 'rgba(217,59,59,1)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '補充ステータス名',
        field: 'stsuppTx',
        width: this.getColumnWidth('stsuppTx', 130),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tc', 'cellclass'],
        cellStyle: function (params) {
          //ステータス色変化
          if (params.value == '未補充' || params.value == '印刷完了') {
            return { backgroundColor: 'rgba(235,153,175,0.2)' };
          } else if (params.value == '補充元出庫開始' || params.value == '補充元出庫完了' || params.value == '補充先入庫開始') {
            return { backgroundColor: 'rgba(227,230,87,0.2)' };
          } else if (params.value == '補充先入庫完了') {
            return { backgroundColor: 'rgba(201,202,202,0.2)' };
          } else {
            return null;
          }
        }
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 130),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '補充番号',
        field: 'suppnoCd',
        width: this.getColumnWidth('suppnoCd', 130),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入数',
        field: 'amountNr',
        width: this.getColumnWidth('amountNr', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '数量',
        field: 'supppcsNr',
        width: this.getColumnWidth('supppcsNr', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '元ロケーション名',
        field: 'srclocaTx',
        width: this.getColumnWidth('srclocaTx', 200),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '先ロケーション名',
        field: 'destlocaTx',
        width: this.getColumnWidth('destlocaTx', 200),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        sort: 'desc',
        width: this.getColumnWidth('addDt', 170),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa5020_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa5020_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa5020_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, 500);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
    this.filterGridByMove();
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.suppService
      .get(this.ownerId)
      .then(outputJson => {
        console.log(outputJson);
        this.originalRowData = outputJson.supps;
        this.gridOptions.api.deselectAll();
        this.filterGridByMove();
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  complete() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    let ownerId: number;
    const selectItems: object[] = [];
    var selectedCount = this.gridOptions.api.getSelectedNodes().length;
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      // const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      var data = this.gridOptions.api.getSelectedNodes()[i].data;
      if(data['stsuppId'] != 1){
          this.errorInfo = '指示書印刷済(印刷完了 ステータス)の補充指示のみを選択してください。';
          return;
      }
      const jsonUnit: object = {
        suppId: data['suppId']
      };
      selectItems.push(jsonUnit);
    }
    console.log(selectItems);
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.suppService
      .complete(selectItems, 'wa5020')
      .then(outputJson => {
        this.working = false;
        sessionStorage.setItem('SuccessInfoMessage', selectedCount + '件の補充指示を完了しました。');

        this.onSubmit();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  print() {
    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.working = false;
      this.errorInfo = '対象を選択して下さい';
      return;
    }
    this.printPDF('RA5001');
  }

  // PDF出力
  //補充タイプのカラム名が未入力
  printPDF(reportCd: string) {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.reportOpened = false;
    this.reporttrnId = 0;
    this.reportTry = 0;
    let suppType = String;
    let selectIdSet = new Set<string>();
    let selectedRows = this.gridOptions.api.getSelectedRows();
    selectedRows.forEach(function (selectedRow, index) {
      selectIdSet.add(selectedRow.suppnoCd);
    });

    let sortedIdSet = new Set<string>();
    this.gridOptions.api.forEachNodeAfterFilterAndSort(function (rowNode) {
      if (selectIdSet.has(rowNode.data.suppnoCd)) {
        sortedIdSet.add(rowNode.data.suppnoCd);
      }
    });

    this.pdfReportService
      .postSpring(reportCd, this.updprogramCd, sortedIdSet)
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        const pdfFilename = outputJson.pdfFilename;
        const popup_window = window.open(environment.pdfPath + pdfFilename);
        this.url = environment.pdfPath + pdfFilename;
        try {
          popup_window.focus();
        } catch (e) {
          this.isShowRemoveModal = true;
        }
        this.working = false;
        this.onSubmit();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  confirmOk() {
    const popup_window = window.open(this.url);
    try {
      popup_window.focus();
    } catch (e) {
      this.isShowRemoveModal = false;
    }
  }

  waitResult(reporttrnId) {
    const obs = Observable.interval(1000).subscribe(() => {
      // Verify that we have not tried more than 10 times
      if (this.reportTry <= 10) {
        // Add a new try to the counter
        this.reportTry++;
        // Call the PDF report service
        this.pdfReportService
          .get(this.reporttrnId)
          .then(outputJson => {
            // If the createdFl is 0 the report has not finished so we retry again.
            // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
            if (outputJson.reports[0].createdFl === 1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.working = false;
              const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
              // We open a new tab to display the PDF.
              // If preferred we could get the PDF data and send the blob to the new tab instead.
              this.openReport(url);
            }
            if (outputJson.reports[0].createdFl === -1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.working = false;
              this.errorInfo = 'データがありません';
            }
          })
          .catch(error => {
            // Cancel the Observable in case of error
            obs.unsubscribe();
            // Change the working flag to false in order to enable the submit button
            this.working = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      } else {
        // Cancel the Observable if the number of tries maxed out
        obs.unsubscribe();
        // Change the working flag to false in order to enable the submit button
        this.working = false;
        this.errorInfo = '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください';
      }
    });
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      this.isShowRemoveModal = true;
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }

  changeOwner(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.originalRowData = [];
      this.filterGridByMove();
      this.gridOptions.api.deselectAll();
    }
  }

  onclick(type) {
    this.Item = type;
    this.isFilterExcludeMoveCompleteChecked = false;
    this.filterGridByMove();
    this.errorMssage = '';
    this.gridOptions.api.deselectAll();
    this.gridOptions.columnApi.setColumnVisible('checkbox', type < 2);
    let pageSize = this.rowData && this.rowData.length > 0 ? this.rowData.length : 0;
    if (type === 0) this.gridOptions.api.paginationSetPageSize(pageSize);
    else if (type === 1) this.gridOptions.api.paginationSetPageSize(pageSize);
    else this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.onSubmit();
  }

  openModalWindow() {
    sessionStorage.setItem('openWindow', 'true');
  }

  filterGridByMove() {
    var filterKeys = [];
    switch (this.Item) {
      case 0:
        filterKeys.push('未補充');
        filterKeys.push('印刷完了');
        break;
      case 1:
        filterKeys.push('補充元出庫開始');
        filterKeys.push('補充元出庫完了');
        filterKeys.push('補充先入庫開始');
        break;
      case 2:
        filterKeys.push('補充先入庫完了');
        break;
      default: {
        if (this.isFilterExcludeMoveCompleteChecked) {
          filterKeys.push('未補充');
          filterKeys.push('印刷完了');
          filterKeys.push('補充元出庫開始');
          filterKeys.push('補充元出庫完了');
          filterKeys.push('補充先入庫開始');
        }
      }
    }

    var bkgFilter = this.gridOptions.api.getFilterModel();
    this.gridOptions.api.setRowData([]);
    this.gridOptions.api.setFilterModel(bkgFilter);

    if (this.originalRowData == null || this.originalRowData.length == 0) return;

    var newRowDatas = [];
    this.originalRowData.forEach(data => {
      if (filterKeys.length == 0 || filterKeys.indexOf(data.stsuppTx) != -1) {
        newRowDatas.push(data);
      }
    });

    if (this.Item == 0) {
      newRowDatas.sort((a, b) => {
        if (a.typesuppTx === '緊急') return -1;
        return 0;
      });
    }

    this.gridOptions.api.updateRowData({
      add: newRowDatas
    });
    this.onRowDataChanged();
  }

  onRowDataChanged() {
    this.errorInfo = '';
    this.gridHelper.onRowDataChanged();
  }

  renderOwnerGrid() {
    this.errorMssage2 = '';
    this.requestOwners();
  }

  requestOwners() {
    this.onOwnerFilterClear();
    this.errorMssage2 = '';
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.ownerRowData = outputJson.owners;
        this.ownerGridHeight = this.ownerGridHelper.getElementHeight(this.el.nativeElement.querySelector('.modal-content__tablearea'));
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorMssage2 = this.commonService.getErrorMessage(error);
      });
  }

  onOwnerFilterClear() {
    this.ownerGridOptions.api.setFilterModel(null);
  }

  onFilterExcludeMoveCompleteCheck() {
    this.filterGridByMove();
  }


  onShow5030Change(isCloseAndRefreshGrid: boolean) {
    this.isShow5030 = false;
    this.onSubmit();
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa5Move/wa5020/wa5020.component.ts